import Toastify from 'toastify-js';

import { apiRequest } from '@common/api/utils';
import { getPlatform } from '@common/vanilla_ui/tracking/attribution';

const formClass = 'form-flow';
const bannerClass = 'banner';
const callbackTriggerClass = `${bannerClass}__counselling-cta`;
const callbackCtaClass = `${bannerClass}__cta`;
const waitlistModalId = 'waitlist-modal';

const activeWaitlistMode = document.querySelector(
  `#${waitlistModalId} .${formClass}__mode--active`,
);
const callbackTriggerEls = document.querySelectorAll(
  `.${callbackTriggerClass}`,
);
const callbackCtaEls = document.querySelectorAll(`.${callbackCtaClass}`);
const parentFormEl = document.querySelector(`.${formClass}__modes`);

const getProduct = () => {
  const url = new URL(window.location.href);
  let urlPathArrs = url.pathname.split('/');
  urlPathArrs = urlPathArrs.filter(path => path !== '');
  if (urlPathArrs.includes('admission')) {
    return 'admission_page';
  }
  return 'landing_page';
};

const getPayload = () => {
  const product = getProduct();
  let source = 'Landing Page RCB';
  let element = 'ug_landing_page_banner_rcb_btn';
  switch (product) {
    case 'admission_page':
      source = 'Admission Page RCB';
      element = 'ug_admission_page_banner_rcb_btn';
      break;
    case 'landing_page':
    default:
      source = 'Landing Page RCB';
      element = 'ug_landing_page_banner_rcb_btn';
      break;
  }

  return {
    program: 'school_of_tech',
    source,
    rcb_prams: {
      attributions: {
        program: 'school_of_tech',
        product: 'scaler',
        intent: 'requested_callback',
        sub_product: 'undergrad',
        element,
        platform: getPlatform(),
      },
    },
  };
};

async function callbackRequest() {
  let message = 'Something went wrong, please refresh and try again.';
  const payLoad = getPayload();
  try {
    await apiRequest(
      'POST',
      '/api/v3/callbacks',
      {
        ...payLoad,
      },
    );
  } catch (error) {
    message = error.responseJson?.message || message;
    Toastify({
      text: message,
      className: 'toastify-danger',
    }).showToast();
  }
}

function showCallbackModal() {
  [...callbackTriggerEls].forEach(callbackTriggerEl => {
    callbackTriggerEl.setAttribute('data-target', 'counselling-modal');
    callbackTriggerEl.addEventListener('click',
      () => { callbackRequest(); });
  });
}

function initialize() {
  if (activeWaitlistMode && callbackCtaEls) {
    [...callbackCtaEls].forEach((callbackCtaEl) => {
      callbackCtaEl.addEventListener('click', () => {
        parentFormEl?.setAttribute('data-success-action', 'book_counselling');
      });
    });
  } else {
    showCallbackModal();
  }
}

export default { initialize, callbackRequest, showCallbackModal };
